import { generateSimpleId } from 'frontendMyOrders/utils'
import { formatDate } from 'frontendMyOrders/utils/formatters'
import { Stack } from '@backyard-ui/core'

import { Divider, MessageBox } from '../../componentsRefact'
import { useAppSelector } from '../redux/store'
import type { MessageType } from '../types'
import { isSameDate } from '../utils/isSameDate'
import useChat from './useChat'

const Chat = () => {
  const messages = useAppSelector(state => state.messages)
  const properties = useAppSelector(state => state.properties)

  const {
    onOptionClick,
    onSubOptionClick,
    onTernaryOptionClick,
    onContactOptionClick
  } = useChat()

  const nameForMessageBox = (from: string) => {
    switch (from) {
      case 'bot':
        return 'Leroy Merlin Automático'
      case 'user':
        return properties.data.userName
      case 'seller':
        return properties.data.shopName
      default:
        return 'Leroy Merlin Automático'
    }
  }

  const renderMessages = (messages: MessageType[]) => {
    return messages.map((message, index) => {
      const currentMessageDate = new Date(message.time)
      let showDivider = false

      if (index === 0) {
        showDivider = true
      } else {
        const previousMessageDate = new Date(messages[index - 1].time)
        showDivider = !isSameDate(currentMessageDate, previousMessageDate)
      }

      return (
        <div key={generateSimpleId()}>
          {showDivider && (
            <Divider
              text={formatDate(message.time, 'long_weekday_day_month')}
            />
          )}
          <MessageBox
            timestamp={formatDate(message.time, 'short_hour')}
            type={message.from}
            message={message.text}
            name={nameForMessageBox(message.from)}
            attachments={message.attachments}
            options={message.options}
            onOptionClick={onOptionClick}
            subOptions={message.subOptions}
            onSubOptionClick={onSubOptionClick}
            ternaryOptions={message?.ternaryOptions}
            ternarySelected={message.ternarySelected ?? ''}
            onTernaryOptionClick={onTernaryOptionClick}
            contactOptions={message.contactOptions}
            onContactOptionClick={onContactOptionClick}
            isOnMobileApp={properties.data.isOnMobileApp}
          />
        </div>
      )
    })
  }

  const shouldRenderMessages = messages?.data.list && properties

  if (!shouldRenderMessages) {
    return null
  }

  return (
    <Stack direction="column" spacing={4} className="m-4">
      {renderMessages(messages.data.list)}
    </Stack>
  )
}

export default Chat
